export default [
  {
    path: '/app/laboratory',
    name: 'Lab',
    component: () => import('@/views/Admin/Laboratory/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory/policy',
    name: 'LaboratoryPolicy',
    component: () => import('@/views/Admin/Laboratory_policy/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Politikamız',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory/service-terms',
    name: 'LaboratoryServiceTerms',
    component: () => import('@/views/Admin/Laboratory_service_terms/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Hizmet Şartlarımız',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
]
